import { BuilderConfiguration,
  BuilderConfigurationElement,
  BuilderElement,
  BuilderElementOption,
  BuilderFunction,
  BuilderGroup,
  BuilderGroupContent,
  BuilderGroupDataType,
  BuilderGroups,
  OptionTypeDate }                                                                                                          from '@/views/x-axis-report/report-edit/types/types';
import { ObjectWithStringKeys }                                                                            from '@/types';
import { XAxisReportPanelGroups }                                                                          from '@/views/x-axis-report/report-edit/helpers/x-axis-report.variables';
import { Elements }                                                                                        from '@/helpers/variables';
import { generateLeadTimeRange, getDateRangeEachDay, isElementLeadTime, isElementTypeDate, isGroupFilter } from '@/views/x-axis-report/report-edit/helpers/x-axis.report-general.helpers';
import { generateCalculateElementConfiguration }                                                           from '@/views/x-axis-report/report-edit/helpers/side-panel/x-axis-report-side-panel.helpers';
import { ElementOptionStyle }                                                                              from '@/components/chart/chart-tooltip/chart-tooltip.types';

export const getCalculateConfiguration = (group: BuilderGroups): ObjectWithStringKeys<BuilderConfiguration[]> => {
  let configuration: ObjectWithStringKeys<BuilderConfiguration[]> = {};

  Object.values(XAxisReportPanelGroups)
    .forEach((key: XAxisReportPanelGroups) => {
      const { data }: { data: BuilderGroupDataType } = group[ key as keyof BuilderGroups ] as BuilderGroup<BuilderGroupDataType>;

      configuration = {
        ...configuration,
        [ key ]: data
          .map((content: BuilderGroupContent, index: number) => {
            if (key === XAxisReportPanelGroups.FUNCTIONS) {
              const contentFunction: BuilderFunction = content as BuilderFunction;

              if (contentFunction.isSelected) {
                return {
                  function: contentFunction.aggregationFunction,
                  type: contentFunction.lineStyle,
                  order: contentFunction.order ?? index,
                  color: contentFunction.color,
                };
              }
            } else if (isGroupFilter(key)) {
              const element: BuilderElement = content as BuilderElement;

              if (isElementTypeDate(element) || isElementLeadTime(element)) {
                if (!!element.value?.from && !!element.value?.to) {
                  const options: string[] | OptionTypeDate[] = isElementLeadTime(element)
                    ? generateLeadTimeRange(element.value.from, element.value.to)
                    : [
                      {
                        min: element.value.from,
                        max: element.value.to,
                      },
                    ];

                  return {
                    ...generateCalculateElementConfiguration(element),
                    options,
                  } as BuilderConfigurationElement;
                }
              } else {
                return {
                  ...generateCalculateElementConfiguration(element),
                  options: element.options
                    ?.filter((option: BuilderElementOption) => option.isSelected)
                    .map((option: BuilderElementOption) => option.name) || [],
                } as BuilderConfigurationElement;
              }
            } else {
              const element: BuilderElement = content as BuilderElement;
              const from = typeof element.value?.from === 'object' ? (element.value?.from as ElementOptionStyle)?.name : element.value?.from;
              const to = typeof element?.value?.to === 'object' ? (element.value?.to as ElementOptionStyle)?.name : element.value?.to;

              if (isElementTypeDate(element) || isElementLeadTime(element)) {
                if (!!from && !!to) {
                  const options: string[] = element.columnName === Elements.LEAD_TIME
                    ? generateLeadTimeRange(from.toString(), to.toString())
                    : getDateRangeEachDay(from.toString(), to.toString());

                  return {
                    ...generateCalculateElementConfiguration(element),
                    options: options
                      .map((option: string, order: number) => ({
                        name: option,
                        order,
                        color: null,
                      })),
                  } as BuilderConfigurationElement;
                }
              } else {
                return {
                  ...generateCalculateElementConfiguration(element),
                  leadElement: element.leadElement,
                  options: element.options
                    ?.filter((option: BuilderElementOption) => option.isSelected)
                    .map((option: BuilderElementOption) => ({
                      name: option.name,
                      order: option.order,
                      color: option.color || null,
                    })) || [],
                } as BuilderConfigurationElement;
              }
            }

            return undefined;
          })
          .filter((element: BuilderConfiguration | undefined) => (
            key === XAxisReportPanelGroups.FUNCTIONS
              ? element
              : (element && ((element as BuilderConfigurationElement).options?.length || false)))) as BuilderConfiguration[],
      };
    });

  return configuration;
};
